import React from 'react';
import { useCountdown } from './useCountdown';
import { Clock, Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
export function FinalCta() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(84455);
  return <section className="py-20 px-4 bg-brand-900 text-white" data-id="element-125">
      <div className="max-w-4xl mx-auto text-center" data-id="element-126">
        <div className="mb-12" data-id="element-127">
          <h2 className="text-2xl font-bold text-brand-200 mb-6 flex items-center justify-center gap-2" data-id="element-128">
            <Clock className="w-6 h-6" data-id="element-129" /> ⏰ EL PRECIO CIERRA EN:
          </h2>
          <div className="flex justify-center gap-4" data-id="element-130">
            <div className="flex flex-col items-center" data-id="element-131">
              <div className="bg-white text-brand-900 text-3xl md:text-4xl font-black py-2 px-4 rounded-lg min-w-[70px]" data-id="element-132">
                {hours}
              </div>
            </div>
            <div className="text-3xl md:text-4xl font-black text-white py-1" data-id="element-133">
              :
            </div>
            <div className="flex flex-col items-center" data-id="element-134">
              <div className="bg-white text-brand-900 text-3xl md:text-4xl font-black py-2 px-4 rounded-lg min-w-[70px]" data-id="element-135">
                {minutes}
              </div>
            </div>
            <div className="text-3xl md:text-4xl font-black text-white py-1" data-id="element-136">
              :
            </div>
            <div className="flex flex-col items-center" data-id="element-137">
              <div className="bg-white text-brand-900 text-3xl md:text-4xl font-black py-2 px-4 rounded-lg min-w-[70px]" data-id="element-138">
                {seconds}
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12 text-left" data-id="element-139">
          {/* Condensed Tier 1 */}
          <div className="bg-brand-800 rounded-2xl p-6 border border-brand-700 flex flex-col" data-id="element-140">
            <h3 className="text-xl font-bold text-white mb-1" data-id="element-141">
              📘 MEGAPACK: NO COLAPSAR EN EL MEP
            </h3>
            <p className="text-sm text-brand-200 mb-4" data-id="element-142">
              6 Tomos + 6 Bonos · Primaria y Secundaria
            </p>
            <div className="mb-6" data-id="element-143">
              <span className="text-brand-400 line-through text-sm block" data-id="element-144">
                $47 USD
              </span>
              <span className="text-3xl font-black text-white" data-id="element-145">$13.99 USD</span>
            </div>
            <a href="https://reconectacontigohoy.com/checkouts/cn/hWNEAaRqar5efqxLJ1foiMU6/es-cr?_r=AQABVFTtdz6nBqEj_-ITAOeGUo6Ah7_cs69ZZU0ItEuInME&cart_link_id=Yb9f0kdY&preview_theme_id=151921262765" target="_blank" rel="noopener noreferrer" className="mt-auto block w-full py-3 px-4 text-center font-bold text-brand-900 bg-white hover:bg-brand-50 rounded-xl transition-colors" data-id="element-146">
              → QUIERO MI MEGAPACK
            </a>
          </div>

          {/* Condensed Tier 2 */}
          <div className="bg-accent-600 rounded-2xl p-6 border border-accent-500 flex flex-col shadow-xl" data-id="element-147">
            <h3 className="text-xl font-bold text-white mb-1" data-id="element-148">
              🏆 MEGAPACK + DOCENTE MEMORABLE ⭐
            </h3>
            <p className="text-sm text-accent-200 mb-4" data-id="element-149">
              6 Tomos + 6 Bonos + Sistema de Pedagogía de Alto Impacto
            </p>
            <div className="mb-6" data-id="element-150">
              <span className="text-accent-300 line-through text-sm block" data-id="element-151">
                $67 USD
              </span>
              <span className="text-3xl font-black text-white" data-id="element-152">$19.99 USD</span>
            </div>
            <a href="https://reconectacontigohoy.com/checkouts/cn/hWNEAawhQdPQHHWbnZeyr4q2/es-cr?_r=AQABFOg9s6RtaukgDYdYeARgz85DpAvUzaSQD6K5iWKvLFk&cart_link_id=ajKw4Caz&preview_theme_id=151921262765" target="_blank" rel="noopener noreferrer" className="mt-auto block w-full py-3 px-4 text-center font-bold text-accent-600 bg-white hover:bg-stone-50 rounded-xl transition-colors" data-id="element-153">
              → QUIERO EL MEGAPACK + DOCENTE MEMORABLE
            </a>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-brand-200 font-medium" data-id="element-154">
          <div className="flex items-center gap-1.5" data-id="element-155">
            <Lock className="w-4 h-4" data-id="element-156" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-1.5" data-id="element-157">
            <Zap className="w-4 h-4" data-id="element-158" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-1.5" data-id="element-159">
            <ShieldCheck className="w-4 h-4" data-id="element-160" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-1.5" data-id="element-161">
            <CreditCard className="w-4 h-4" data-id="element-162" /> Tarjeta | Transferencia SINPE |
            PayPal
          </div>
        </div>
      </div>
    </section>;
}